import {AuthErrorType} from '../store/authStore';

export class AuthError extends Error {
    public type: AuthErrorType;

    constructor(type: AuthErrorType) {
        super('AuthError');
        this.type = type;
    }
}
